import {action, computed, makeObservable, observable} from "mobx";

export default class FormField {
    constructor(isOptional = false, initialValue = "", feature = undefined) {
        this._initialValue = initialValue;
        this._value = initialValue || this.defaultValue();
        this._errors = [];
        this._validators = [];
        this._isOptional = isOptional;
        this._feature = feature;

        makeObservable(this, {
            _value: observable,
            _errors: observable,
            hasErrors: computed,
            isValid: computed,
            value: computed,
            errors: computed,
            updateValue: action,
            clear: action,
            setErrors: action,
        });
    }

    initialValue() {
        return this._initialValue;
    }

    get value() {
        return this._value;
    }

    get errors() {
        return this._errors;
    }

    defaultValue() {
        return "";
    }

    setErrors(errors) {
        this._errors = errors;
    }

    updateValue(value) {
        this._value = value;
        if (this._feature) {
            this._feature.aValueChanged?.()
        }
    }

    updateInitialValue(value) {
        this._initialValue = value;
    }

    clear() {
        this._value = this.defaultValue();
        this._errors = [];
    }

    get hasValue() {
        return this.value !== this.defaultValue();
    }

    get isValid() {
        if (this._isOptional && this._value === this.defaultValue()) {
            return true;
        }
        if (!this._isOptional && (this._value === "" || this._value === undefined)) {
            return false;
        }
        return this._validators.every((validator) => validator.isValid(this._value));
    }

    get hasErrors() {
        return this._errors.length > 0;
    }

    get isOptional(){
        return this._isOptional
    }

    asOptional() {
        this._isOptional = true;
        return this;
    }
}
